import { useCmsContext } from '../../contexts/cms'

export const useEntity = <TEntity = any>(): TEntity => {
  const { entity } = useCmsContext()

  return entity
}
